
// import React from 'react';
// import WhatsAppIcon from "../assets/images/whatsapp-icon.svg"
// import { Input } from 'antd';
// import Search from 'antd/lib/input/Search';

// function ChatList({ chats, onSelectChat }) {
//   return (
//     <div className="chat-list">
//       <div className='chat-list-header'>
//         <Search placeholder="input search text" />
//       </div>
//       <div className='chat-listing-body'>
//         {chats.map(chat => (
//           <div
//             key={chat.id}
//             className="chat-item"
//             onClick={() => onSelectChat(chat)}
//           >
//             <img width={25} src={WhatsAppIcon} /> <span>{chat.name || chat.id}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default ChatList;


import React, { useState } from 'react';
import WhatsAppIcon from "../assets/images/whatsapp-icon.svg";
import { Input } from 'antd';
const { Search } = Input;

function ChatList({ chats, onSelectChat, onScrollEnd }) {
  const [searchTerm, setSearchTerm] = useState("");
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      onScrollEnd();
    }
  };
  const filteredChats = chats.filter(chat =>
    chat.number?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    chat.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="chat-list" >
      <div className='chat-list-header' style={{ padding: '10px' }}>
        <Search allowClear
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)} placeholder="Search chat..." />
      </div>
      <div className='chat-listing-body' style={{ height: '500px', overflowY: 'auto' }} onScroll={handleScroll}>
        {filteredChats.map(chat => (
          <div
            key={chat.id}
            className="chat-item"
            onClick={() => onSelectChat(chat)}
            style={{ padding: '10px', borderBottom: '1px solid #eee', cursor: 'pointer' }}
          >
            <img width={25} src={WhatsAppIcon} alt="icon" style={{ marginRight: '8px' }} />
            <span>{chat.number}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ChatList;
